import { render, staticRenderFns } from "./SchoolSearch.vue?vue&type=template&id=57184b51&scoped=true"
import script from "./SchoolSearch.vue?vue&type=script&lang=js"
export * from "./SchoolSearch.vue?vue&type=script&lang=js"
import style0 from "./SchoolSearch.vue?vue&type=style&index=0&id=57184b51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57184b51",
  null
  
)

export default component.exports